import { Box, Grid } from "@mui/material";
import DistribuicaoFalhasChart from "./DistribuicaoFalhasChart";
import FalhasCriticasRecentes from "./FalhasCriticasRecentes";
import { RopCard1112CriticalAlertsAndDeviationsTaticoAggregated } from "../../types";

interface AlertasCriticosDesviosProps {
    data: RopCard1112CriticalAlertsAndDeviationsTaticoAggregated;
    clusterId?: string;
    usinaId?: number;
}

export default function AlertasCriticosDesvios({ data: _data, clusterId, usinaId }: AlertasCriticosDesviosProps) {

    return (
        <Box
            sx={{
                borderRadius: "8px",
                padding: "20px 6px",
                width: "100%",
                height: "100%",
            }}
        >
            <Grid container spacing={3} sx={{ height: "100%", alignItems: "stretch" }}>
                <Grid item xs={12} md={6} sx={{ display: "flex" }}>
                    <Box sx={{ width: "100%", height: "100%" }}>
                        <DistribuicaoFalhasChart
                            clusterId={clusterId}
                            usinaId={usinaId}
                        />
                    </Box>
                </Grid>
                <Grid item xs={12} md={6} sx={{ display: "flex" }}>
                    <Box sx={{ width: "100%", height: "100%" }}>
                        <FalhasCriticasRecentes
                            clusterId={clusterId}
                            usinaId={usinaId}
                        />
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
}
